<template>
	<router-view />
</template>

<script>
export default {
	name: "Fleet"
};
</script>
